import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionCard, EmptyState } from "@/components/common/Primitives";
import { Bell, CheckCheck } from "lucide-react";

export default function NotificationsPage() {
  const [notifs, setNotifs] = useState([]);
  useEffect(() => { api.get("/notifications").then(({ data }) => setNotifs(data)); }, []);
  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    setNotifs(notifs.map((n) => n.id === id ? { ...n, read: true } : n));
  };
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[11px] uppercase tracking-[0.16em] text-slate-500 font-semibold">Inbox</div>
        <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-slate-900">Notifications</h1>
      </div>
      <SectionCard title="All notifications" subtitle={`${notifs.filter((n) => !n.read).length} unread`}>
        {notifs.length === 0 ? <EmptyState /> : (
          <div className="space-y-2">
            {notifs.map((n) => (
              <div key={n.id} className={`flex items-start gap-3 p-3 border border-slate-200 rounded-md ${n.read ? "opacity-70" : "bg-blue-50/40"}`}>
                <div className="h-9 w-9 rounded-md bg-blue-100 text-blue-700 grid place-items-center shrink-0"><Bell size={14} /></div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-slate-900">{n.title}</div>
                  <div className="text-xs text-slate-600 mt-0.5">{n.message}</div>
                  <div className="text-[10px] text-slate-400 mt-1">{new Date(n.timestamp).toLocaleString()}</div>
                </div>
                {!n.read && (
                  <button onClick={() => markRead(n.id)} className="text-xs text-sams-primary hover:underline flex items-center gap-1" data-testid={`notif-read-${n.id}`}>
                    <CheckCheck size={12} /> Mark read
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </SectionCard>
    </div>
  );
}
